import type { ReactNode } from "react";
import { StyleSheet, View, type ViewProps } from "react-native";

import { AppText } from "./AppText";
import { Row } from "./Row";
import { Stack } from "./Stack";
import type { Space } from "./types";

export function Section({
  title,
  description,
  action,
  gap = "md",
  children,
  style,
  ...props
}: ViewProps & {
  title?: string;
  description?: string;
  action?: ReactNode;
  gap?: Space;
}) {
  return (
    <View style={style} {...props}>
      <Stack gap={gap}>
        {title || description || action ? (
          <Row between align="start" gap="md">
            <Stack gap="xs" style={stylesheet.heading}>
              {title ? (
                <AppText size="base" weight="semibold">
                  {title}
                </AppText>
              ) : null}
              {description ? (
                <AppText size="xs" tone="muted">
                  {description}
                </AppText>
              ) : null}
            </Stack>
            {action}
          </Row>
        ) : null}
        {children}
      </Stack>
    </View>
  );
}

const stylesheet = StyleSheet.create({ heading: { flex: 1, minWidth: 0 } });
